var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebflowicon = function SvgWebflowicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16 3-5.105 9.841H6.099l2.137-4.078H8.14C6.377 11.019 3.747 12.505 0 12.842V8.819s2.397-.14 3.807-1.6H0V3h4.278v3.47h.096L6.122 3h3.236v3.448h.096L11.267 3H16Z",
    clipRule: "evenodd"
  })));
};
export default SvgWebflowicon;